<template>
  <div class="mb-4">
    <div v-if="!joindisucssion">
      <b-card no-body class="border-none p-4 mb-4">
        <div class="flex justify-between items-center">
          <div class="flex items-center">
            <img alt="user" class="w-9 rounded-full" :src="item.userImg" />
            <p class="font-bold text-sm ml-4">
              {{ item.userName }}
              <span class="font-normal"> has started a discussion </span>
            </p>
          </div>
          <base-button
            size="sm"
            type="primary"
            class="rounded-lg px-3 py-0"
            @click="joindisucssion = true"
            >Join</base-button
          >
        </div>
        <div class="mt-2">
          <p class=" text-base font-semibold">
            {{ item.postDescription }}
          </p>
        </div>
        <div class="mt-2">
          <p class=" text-sm font-normal leading-6 text-muted">
            {{ item.discussDescription }}
            <span class="text-primary cursor-pointer">(more)</span>
          </p>
        </div>
        <div class="mt-4 ">
          <img alt="" class="rounded-lg" :src="item.postImg" />
        </div>
      </b-card>
    </div>
    <div v-show="joindisucssion">
      <JoinDisucssion />
    </div>
  </div>
</template>

<script>
import JoinDisucssion from "./JoinDisucssion.vue";
export default {
  components: {
    JoinDisucssion
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      joindisucssion: false
    };
  }
};
</script>
